import { Button, Card, Col, Row } from 'react-bootstrap';
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import logoImg from '../../assets/images/logo-light.png';
import ComponentPrint from './ComponentPrint';
const ProcessNominas = ({ nominas }) => {
    const contentRef = useRef();
    const handleGeneratePdf = () => {
        const element = contentRef.current;

        const opt = {
            filename: 'documento.pdf', // Nombre del archivo PDF
            margin: [10, 10, 10, 10], // [top, left, bottom, right]
            html2canvas: {
                useCORS: true, // Habilitar el uso de CORS (opcional, necesario si hay problemas con las imágenes)
                scale: 2,
            },
            jsPDF: {
                orientation: 'portrait',
            },
        };

        const loadImages = () => {
            const images = element.getElementsByTagName('img');
            const totalImages = images.length;
            let imagesLoaded = 0;

            return new Promise((resolve, reject) => {
                if (totalImages === 0) {
                    resolve();
                } else {
                    for (let i = 0; i < totalImages; i++) {
                        images[i].addEventListener('load', () => {
                            imagesLoaded++;
                            if (imagesLoaded === totalImages) {
                                resolve();
                            }
                        });
                        images[i].addEventListener('error', () => {
                            reject(new Error('Error loading images'));
                        });
                        // En caso de que la imagen ya esté cargada en caché
                        if (images[i].complete) {
                            imagesLoaded++;
                            if (imagesLoaded === totalImages) {
                                resolve();
                            }
                        }
                    }
                }
            });
        };

        loadImages()
            .then(() => {
                html2pdf()
                    .from(element)
                    .set(opt)
                    .output('blob')
                    .then((pdfBlob) => {
                        // Crear un objeto URL para el PDF
                        const pdfUrl = URL.createObjectURL(pdfBlob);

                        // Abrir el PDF en una nueva pestaña para imprimir
                        const pdfWindow = window.open(pdfUrl);
                        pdfWindow.addEventListener('load', () => {
                            pdfWindow.print();
                        });
                    });
            })
            .catch((error) => {
                console.error('Error generating PDF:', error);
            });
    };

    return (
        <Col>
            <Card>
                <div className="d-print-none mt-4">
                    <div className="text-end">
                        <button className="btn btn-primary me-1" onClick={handleGeneratePdf}>
                            <i className="mdi mdi-printer"></i>Imprimir
                        </button>
                    </div>
                </div>
                <Card.Body>
                    <div id="print" ref={contentRef}>
                        {nominas.map((data) => (
                            <div key={data.id} style={{ pageBreakAfter: 'always', breakAfter: 'page' }}>
                                <ComponentPrint data={data} />
                            </div>
                        ))}
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default ProcessNominas;
